function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.7478 1H3.17957C1.94448 1 1 2.05796 1 3.44145V12.4748C1 13.7769 1.94448 14.9163 3.17957 14.9163H5.06852V18.4449C5.06852 18.9332 5.57709 19.1773 5.8677 18.8518L10.5174 14.9163H14.8204C15.9829 14.9163 17 13.8583 17 12.4748V3.44145C16.8547 2.05796 15.9102 1 14.7478 1Z",
  stroke: "#A2A7B0",
  strokeMiterlimit: 10
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.36816 6.40039H13.6313",
  stroke: "#A2A7B0",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  d: "M4.36816 10H9.4208",
  stroke: "#A2A7B0",
  strokeMiterlimit: 10,
  strokeLinecap: "round"
});

var SvgMessage = function SvgMessage(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgMessage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/message.c2f0ebe8.svg";
export { ForwardRef as ReactComponent };